module.exports = __webpack_public_path__ + "img/tn-timeline-main-1.98c4d59c.jpg";